import * as React from 'react'
import type {HTMLAttributes} from 'react'

import SvgIcon from '../../../../common/SvgIcon/SvgIcon'
import MatchingItem from '../MatchingItem/MatchingItem'

type Props = HTMLAttributes<HTMLDivElement> & {
  title?: string
  matching?: boolean
  searchQuery?: string
  className?: string
}
export default function LinearAgentType({title, className, searchQuery, ...htmlProps}: Props) {
  return (
    <span className={className} {...htmlProps}>
      <SvgIcon icon="cloud" /> <MatchingItem searchQuery={searchQuery}>{title}</MatchingItem>
    </span>
  )
}
